module.exports = (__webpack_require__(5))("./src/static-aei/index.js");